import { createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "relative inline-flex" };
const _hoisted_2 = { class: "actions-menu" };
const _hoisted_3 = { class: "actions-list p-0" };
const _hoisted_4 = { class: "general-actions" };
const _hoisted_5 = { class: "section-heading" };
const _hoisted_6 = { class: "section-heading" };
const _hoisted_7 = { class: "section-heading" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode($setup["EnMenu"], {
                class: "p-1 z-2500",
                ref: "menuComponent",
                side: "bottom",
                align: "end"
            }, {
                trigger: _withCtx(() => [
                    _createVNode($setup["EnButton"], {
                        ref: "button",
                        class: "actions-menu-button",
                        size: "icon",
                        tooltip: $setup.t('common.dataGrid.actions.tooltip'),
                        "static-id": $setup.buildId('action-visibility-menu', $props.staticId),
                        "tooltip-location": "bottom"
                    }, {
                        icon: _withCtx(() => [
                            _createVNode($setup["EllipsisIcon"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip", "static-id"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", null, _toDisplayString($setup.t('common.dataGrid.actions.general')), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", null, [
                                _createVNode($setup["EnMenuItem"], {
                                    "static-id": "reload-menu-item",
                                    onClick: $setup.reload
                                }, {
                                    icon: _withCtx(() => [
                                        _createVNode($setup["RefreshIcon"])
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(" " + _toDisplayString($setup.t('common.dataGrid.actions.reload')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ]),
                        ($setup.hasModuleSpecificActions)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "module-specific-actions",
                                onClick: _cache[0] || (_cache[0] = ($event) => ($setup.closeMenu()))
                            }, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", null, _toDisplayString($setup.t('common.dataGrid.actions.moduleActions')), 1 /* TEXT */)
                                ]),
                                _renderSlot(_ctx.$slots, "moduleSpecificActions", {}, undefined, true)
                            ]))
                            : _createCommentVNode("v-if", true),
                        ($setup.hasBatchProcessActions)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "batch-process-actions",
                                onClick: _cache[1] || (_cache[1] = ($event) => ($setup.closeMenu()))
                            }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", null, _toDisplayString($setup.batchProcessTitle), 1 /* TEXT */)
                                ]),
                                _renderSlot(_ctx.$slots, "batchProcessActions", {}, undefined, true)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 512 /* NEED_PATCH */)
        ]),
        _createVNode($setup["EnOverlayBadge"], {
            count: $setup.batchProcessItemCount,
            class: "top-0 right-0 -translate-y-1/2 translate-x-1/2"
        }, null, 8 /* PROPS */, ["count"])
    ]));
}
